import Reveal from "../components/Reveal";
import { QuoteWizard } from "../components/contact/QuoteWizard";
import { ContactThanks } from "../components/contact/ContactThanks";
import { ContactInfo } from "../components/contact/ContactInfo";
import { useContactForm } from "../hooks/useContactForm";
import { Seo } from "../components/Seo";
import { useT } from "../i18n/I18nProvider";

export default function Contact() {
  const t = useT();
  const { form, busy, sent, setSent, update, setField, submit, services } =
    useContactForm();

  return (
    <>
      <Seo page="contatti" />
      {/* HEADER */}
      <section className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 pt-16 md:pt-24 pb-14 md:pb-20 grid lg:grid-cols-12 gap-8 md:gap-10 items-end">
        <div className="lg:col-span-8">
          <Reveal>
            <div className="overline mb-4 md:mb-6">
              {t("contact.header.overline")}
            </div>
          </Reveal>
          <Reveal delay={80}>
            <h1 className="font-display text-5xl sm:text-7xl md:text-8xl lg:text-[9vw] leading-[0.92] tracking-tightest">
              {t("contact.header.title1")}
              <br /> {t("contact.header.title2")}{" "}
              <span className="font-editorial text-ink-700">
                {t("contact.header.titleEditorial")}
              </span>
              {t("contact.header.titleEnd")}
            </h1>
          </Reveal>
        </div>
        <div className="lg:col-span-4">
          <Reveal delay={160}>
            <p className="text-[15px] md:text-[16px] text-ink-500 leading-relaxed">
              {t("contact.header.paragraph")}
            </p>
          </Reveal>
        </div>
      </section>

      {/* FORM + INFO */}
      <section className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 pb-16 md:pb-24 grid lg:grid-cols-12 gap-6 md:gap-10">
        <Reveal className="lg:col-span-7 card-flat p-6 md:p-12">
          {sent ? (
            <ContactThanks onAgain={() => setSent(false)} />
          ) : (
            <QuoteWizard
              form={form}
              busy={busy}
              update={update}
              setField={setField}
              submit={submit}
              services={services}
            />
          )}
        </Reveal>
        <ContactInfo />
      </section>
    </>
  );
}
